const TechBtn = () => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Icons'>
        <path
          id='TV-Guide'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.75 1.93518H2.25C1.00804 1.93683 0.00165264 2.94323 0 4.18518V15.1852C0.00165264 16.4271 1.00804 17.4335 2.25 17.4352H10.25C10.5261 17.4352 10.75 17.659 10.75 17.9352V19.4352C10.75 19.7113 10.5261 19.9352 10.25 19.9352H7.25C6.55964 19.9352 6 20.4948 6 21.1852C6 21.8755 6.55964 22.4352 7.25 22.4352H16.75C17.4404 22.4352 18 21.8755 18 21.1852C18 20.4948 17.4404 19.9352 16.75 19.9352H13.75C13.4739 19.9352 13.25 19.7113 13.25 19.4352V17.9352C13.25 17.659 13.4739 17.4352 13.75 17.4352H21.75C22.992 17.4335 23.9983 16.4271 24 15.1852V4.18518C23.9983 2.94323 22.992 1.93683 21.75 1.93518ZM21.4999 14.4352C21.4999 14.7113 21.2761 14.9352 20.9999 14.9352H2.99993C2.72379 14.9352 2.49993 14.7113 2.49993 14.4352V4.93518C2.49993 4.65903 2.72379 4.43518 2.99993 4.43518H20.9999C21.2761 4.43518 21.4999 4.65903 21.4999 4.93518V14.4352Z'
          fill='#8D8D8C'
        />
      </g>
    </svg>
  );
};

export default TechBtn;
